<template>
  <div class="input_box" :style="{width: inputWidth}">
    <span class="search">
      <el-input
        v-model="value"
        style="width: 100%;"
        :placeholder="placeholder"
        :type="type"
        class="input-with-select"
        clearable
        @keyup.native.enter="onChange"
        @clear="onChange"
        @change="onChange"
      >
        <el-button
          slot="suffix"
          icon="el-icon-search"
          @click="onChange"
        />
      </el-input>
    </span>
  </div>
</template>

<script>
export default {
  name: 'SearchInput',
  model: {
    prop: 'modelVal',
    event: 'change'
  },
  props: {
    placeholder: {
      type: String,
      default: '搜索'
    },
    type: {
      type: String,
      default: 'text'
    },
    inputWidth: {
      type: String,
      default: '100%'
    },
    modelVal: {
      type: String
    }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {
    // 监听传入值
    modelVal() {
      if (this.modelVal) {
        this.value = this.modelVal
      }
    }
  },
  created() {
    if (this.modelVal) {
      this.value = this.modelVal
    }
  },
  methods: {
    onChange() {
      this.$emit('modify', this.value)
      this.$emit('change', this.value)
    }
  }

}
</script>

<style lang='less' scoped>
.input_box {
  float: left;
  margin-right: 20px;
  height: 32px;
}
/deep/.search {
  .el-input {
    position: relative;
    width: 100%;
    border: 1px solid #d8e1f2;
    border-radius: 20px;
  }

  .el-input__inner {
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    border: none;
  }

  .el-input__inner {
    height: 36px;
    line-height: 36px;
  }

  .el-button {
    position: absolute;
    right: 0;
    top: 4px;
    background-color: #ffffff;
    border: none;
    padding: 8px;
  }

  .el-button:hover {
    color: #3150e9;
    background-color: #fff;
    border: none;
    box-shadow: none;
  }

  .el-button:focus {
    background-color: #fff;
    color: #3150e9;
    border: none;
  }

}
</style>
